import { render, staticRenderFns } from "./TrsSearch.vue?vue&type=template&id=adcdf47c"
import script from "./TrsSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrsSearch.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports